import { createContext, useContext } from 'react';

import { type Sessao, type UsuarioAtual } from '@fiscoai/contracts';

export type EstadoAuth = 'carregando' | 'anonimo' | 'autenticado';

export interface ContextoAuth {
  estado: EstadoAuth;
  usuario: UsuarioAtual | null;
  /** Chamado pela tela de login com a sessão recebida. */
  entrar: (sessao: Sessao) => Promise<void>;
  sair: () => Promise<void>;
  /** Relê o usuário (permissões e empresas) depois de mudanças que alteram o escopo dele. */
  recarregarUsuario: () => Promise<void>;
}

export const AuthContext = createContext<ContextoAuth | null>(null);

export function useAuth(): ContextoAuth {
  const contexto = useContext(AuthContext);
  if (!contexto) throw new Error('useAuth fora do AuthProvider');
  return contexto;
}

/** Usuário logado — só use dentro de rotas protegidas. */
export function useUsuario(): UsuarioAtual {
  const { usuario } = useAuth();
  if (!usuario) throw new Error('useUsuario sem sessão');
  return usuario;
}
